import React, {FC} from 'react';
import {Markdown} from 'components/Markdown';

import defaultText from './default.md';

import * as styles from './styles.module.scss';

interface NotesProps {
	notes?: string;
}

const Notes: FC<NotesProps> = ({notes}) => (
	<Markdown
		className={styles.text}
		markdown={notes || defaultText}
	/>
);

export default Notes;
